module.exports = __webpack_public_path__ + "static/visual_1-bcc9f774be8d9535d4b21b03fd3afea3.jpg";